// extracted by mini-css-extract-plugin
export default {"container":"HeroTemplate_container__iUW+H","header":"HeroTemplate_header__FQ5Zl","fadein":"HeroTemplate_fadein__SFnXp"};